import Script from 'next/script'

// TODO Move to a dedicated file
declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (options: {
          portalId: string
          formId: string
          target: string
          onFormReady?: (formElement: HTMLFormElement) => void
          onFormSubmitted?: () => void
        }) => void
      }
    }
  }
}

const GatedForm = ({
  portalId,
  formId,
  onSubmitCallback,
}: {
  portalId: string
  formId: string
  onSubmitCallback: () => void
}) => {
  return (
    <div id="hubspot-form-container" style={{ width: '100%', marginTop: '20px' }}>
      <Script
        src="//js.hsforms.net/forms/embed/v2.js"
        onReady={() => {
          window.hbspt?.forms.create({
            portalId: portalId,
            formId: formId,
            target: '#hubspot-form-container',
            onFormSubmitted: () => onSubmitCallback(),
            onFormReady: (form) => {
              // General style
              const style = document.createElement('style')
              style.textContent = `
              .hs_error_rollup {
                text-align: center;
              }
              .hs-form-field {
                margin-bottom: 16px !important;
              }
              .actions{
                margin: 0
              }
              label{
                margin-bottom: 0 !important
              }

              `
              form.appendChild(style)

              // Input labels.
              const inputs = form.querySelectorAll('label')
              inputs.forEach((label: Element) => {
                const labelEl = label as HTMLSpanElement
                labelEl.style.fontWeight = '400'
                labelEl.style.display = 'flex'
                labelEl.style.gap = '6px'
                labelEl.style.color = '#fff'
              })

              // Normal inputs.
              const normalInputs = form.querySelectorAll('.input:has(> input)')
              normalInputs.forEach((inputDiv: Element) => {
                const divEl = inputDiv as HTMLDivElement
                const parentEl = divEl.parentElement as HTMLDivElement
                const labelEl = parentEl.querySelector('label') as HTMLSpanElement
                const inputEl = inputDiv.querySelector('& > input') as HTMLInputElement
                inputEl.style.borderRadius = '12px'
                inputEl.style.border = '1px solid #3D4852'
                inputEl.style.padding = '20px'
                inputEl.style.backgroundColor = '#0A0A0A'
                inputEl.style.color = '#fff'
                inputEl.style.fontSize = '14px'
                labelEl.style.marginBottom = '8px'
                parentEl.style.marginBottom = '46px'
                parentEl.style.display = 'flex'
                parentEl.style.flexDirection = 'column'
                parentEl.style.gap = '12px'
              })

              // Submit button.
              const submitButton = form.querySelector('input[type="submit"]') as HTMLInputElement
              submitButton.style.fontWeight = '500'
              submitButton.style.borderRadius = '30px'
              submitButton.style.fontSize = '16px'
              submitButton.style.padding = '10px 20px'
              submitButton.style.lineHeight = '100%'
              submitButton.style.color = '#EEFAFF'
            },
          })
        }}
      />
    </div>
  )
}

export default GatedForm
